import React, { Component, PropTypes } from 'react';
import './Vaporeon.scss';

class Vaporeon extends Component {
  render() {
    return (
      <div className="pokemon">
        <div className="vaporeon">
          <div className="head">

          </div>
          <div className="body">

          </div>
        </div>
      </div>
    );
  }
}

export default Vaporeon;



/** WEBPACK FOOTER **
 ** ./source/134-vaporeon/Vaporeon.js
 **/